import React, { useState } from 'react';
import { X, ChevronLeft, ChevronRight, Clock, Calendar, Users, FileText, CheckCircle, AlertCircle, Download, Printer, Share2, BarChart, MessageSquare, Edit, ArrowRight, UserPlus, Mail } from 'lucide-react';
export const WorkflowViewerModal = ({
  workflow,
  onClose,
  onEdit
}) => {
  const [activeTab, setActiveTab] = useState('overview');
  if (!workflow) return null;
  return <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center" data-id="element-1673">
      <div className="bg-white w-full max-w-6xl h-[90vh] rounded-lg flex flex-col overflow-hidden" data-id="element-1674">
        {/* Header */}
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between" data-id="element-1675">
          <div className="flex items-center space-x-4" data-id="element-1676">
            <div className="h-10 w-10 bg-blue-100 rounded-md flex items-center justify-center" data-id="element-1677">
              <BarChart className="h-6 w-6 text-blue-600" data-id="element-1678" />
            </div>
            <div data-id="element-1679">
              <h2 className="text-lg font-semibold text-gray-800" data-id="element-1680">
                {workflow.name}
              </h2>
              <p className="text-sm text-gray-500" data-id="element-1681">
                Started {workflow.startDate} • {workflow.status}
              </p>
            </div>
          </div>
          <div className="flex items-center space-x-3" data-id="element-1682">
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-1683">
              <Download className="h-5 w-5" data-id="element-1684" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-1685">
              <Printer className="h-5 w-5" data-id="element-1686" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" data-id="element-1687">
              <Share2 className="h-5 w-5" data-id="element-1688" />
            </button>
            <button className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-full" onClick={onClose} data-id="element-1689">
              <X className="h-5 w-5" data-id="element-1690" />
            </button>
          </div>
        </div>
        {/* Tabs */}
        <div className="px-6 py-2 border-b border-gray-200 flex space-x-6" data-id="element-1691">
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'overview' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('overview')} data-id="element-1692">
            Overview
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'details' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('details')} data-id="element-1693">
            Details
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'documents' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('documents')} data-id="element-1694">
            Documents
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'history' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('history')} data-id="element-1695">
            History
          </button>
          <button className={`py-2 px-1 text-sm font-medium ${activeTab === 'comments' ? 'text-blue-600 border-b-2 border-blue-600' : 'text-gray-600'}`} onClick={() => setActiveTab('comments')} data-id="element-1696">
            Comments
          </button>
        </div>
        {/* Content */}
        <div className="flex-1 overflow-auto" data-id="element-1697">
          {activeTab === 'overview' && <div className="p-6" data-id="element-1698">
              <div className="flex justify-between items-start mb-6" data-id="element-1699">
                <div className="max-w-2xl" data-id="element-1700">
                  <h3 className="text-lg font-medium text-gray-800 mb-2" data-id="element-1701">
                    {workflow.name}
                  </h3>
                  <p className="text-gray-600" data-id="element-1702">{workflow.description}</p>
                </div>
                <div className="flex items-center space-x-3" data-id="element-1703">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${getStatusStyles(workflow.status)}`} data-id="element-1704">
                    {workflow.status}
                  </span>
                  <button className="px-4 py-2 border border-gray-300 rounded-md text-sm text-gray-700 hover:bg-gray-50 transition-colors flex items-center space-x-1" onClick={() => onEdit(workflow)} data-id="element-1705">
                    <Edit className="h-4 w-4" data-id="element-1706" />
                    <span data-id="element-1707">Edit Workflow</span>
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-3 gap-6 mb-8" data-id="element-1708">
                <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1709">
                  <div className="flex items-center mb-2" data-id="element-1710">
                    <Calendar className="h-5 w-5 text-gray-400 mr-2" data-id="element-1711" />
                    <h4 className="text-sm font-medium text-gray-700" data-id="element-1712">
                      Timeline
                    </h4>
                  </div>
                  <div className="space-y-2" data-id="element-1713">
                    <div className="flex justify-between items-center" data-id="element-1714">
                      <span className="text-xs text-gray-500" data-id="element-1715">Started</span>
                      <span className="text-sm text-gray-800" data-id="element-1716">
                        {workflow.startDate}
                      </span>
                    </div>
                    <div className="flex justify-between items-center" data-id="element-1717">
                      <span className="text-xs text-gray-500" data-id="element-1718">Due Date</span>
                      <span className="text-sm text-gray-800" data-id="element-1719">
                        {workflow.dueDate || 'No due date'}
                      </span>
                    </div>
                    <div className="flex justify-between items-center" data-id="element-1720">
                      <span className="text-xs text-gray-500" data-id="element-1721">
                        Expected Completion
                      </span>
                      <span className="text-sm text-gray-800" data-id="element-1722">
                        {getExpectedCompletionDate(workflow)}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1723">
                  <div className="flex items-center mb-2" data-id="element-1724">
                    <Users className="h-5 w-5 text-gray-400 mr-2" data-id="element-1725" />
                    <h4 className="text-sm font-medium text-gray-700" data-id="element-1726">
                      Participants
                    </h4>
                  </div>
                  <div className="flex flex-wrap gap-2" data-id="element-1727">
                    {workflow.participants.map((participant, index) => <div key={index} className="flex items-center bg-gray-100 rounded-full pl-1 pr-3 py-1" data-id="element-1728">
                        <div className="h-5 w-5 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800 mr-1" data-id="element-1729">
                          {participant.initials}
                        </div>
                        <span className="text-xs text-gray-700" data-id="element-1730">
                          {participant.name}
                        </span>
                      </div>)}
                    <button className="flex items-center bg-gray-100 rounded-full px-2 py-1 text-gray-500 hover:bg-gray-200" data-id="element-1731">
                      <UserPlus className="h-3 w-3 mr-1" data-id="element-1732" />
                      <span className="text-xs" data-id="element-1733">Add</span>
                    </button>
                  </div>
                </div>
                <div className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1734">
                  <div className="flex items-center mb-2" data-id="element-1735">
                    <FileText className="h-5 w-5 text-gray-400 mr-2" data-id="element-1736" />
                    <h4 className="text-sm font-medium text-gray-700" data-id="element-1737">
                      Documents
                    </h4>
                  </div>
                  <div className="space-y-2" data-id="element-1738">
                    <div className="text-sm text-gray-600" data-id="element-1739">
                      <span className="font-medium text-gray-800" data-id="element-1740">2</span>{' '}
                      documents attached
                    </div>
                    <div className="text-sm text-gray-600" data-id="element-1741">
                      <span className="font-medium text-gray-800" data-id="element-1742">1</span>{' '}
                      pending approval
                    </div>
                    <button className="text-xs text-blue-600 hover:text-blue-800" data-id="element-1743">
                      View all documents
                    </button>
                  </div>
                </div>
              </div>
              <div className="mb-8" data-id="element-1744">
                <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1745">
                  Workflow Progress
                </h3>
                <div className="relative pb-12" data-id="element-1746">
                  <div className="absolute inset-0 flex items-center justify-center" data-id="element-1747">
                    <div className="w-full border-t border-gray-300" data-id="element-1748"></div>
                  </div>
                  <div className="relative flex justify-between" data-id="element-1749">
                    {workflow.steps.map((step, index) => <div key={index} className="flex flex-col items-center" data-id="element-1750">
                        <div className={`h-12 w-12 rounded-full flex items-center justify-center z-10 ${getStepStatusStyles(step.status)}`} data-id="element-1751">
                          {getStepStatusIcon(step.status)}
                        </div>
                        <div className="text-sm font-medium text-gray-700 mt-2 text-center max-w-[120px]" data-id="element-1752">
                          {step.name}
                        </div>
                        <div className="text-xs text-gray-500 mt-1" data-id="element-1753">
                          {getStepStatusText(step.status)}
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
              <div data-id="element-1754">
                <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1755">
                  Recent Activity
                </h3>
                <div className="space-y-4" data-id="element-1756">
                  {workflowActivities.map((activity, index) => <div key={index} className="flex items-start" data-id="element-1757">
                      <div className="h-8 w-8 rounded-full bg-blue-100 flex items-center justify-center flex-shrink-0" data-id="element-1758">
                        {getActivityIcon(activity.type)}
                      </div>
                      <div className="ml-3" data-id="element-1759">
                        <p className="text-sm text-gray-800" data-id="element-1760">
                          <span className="font-medium" data-id="element-1761">{activity.user}</span>{' '}
                          {activity.description}
                        </p>
                        <p className="text-xs text-gray-500 mt-1" data-id="element-1762">
                          {activity.date}
                        </p>
                        {activity.comment && <div className="mt-2 p-3 bg-gray-50 rounded-md text-sm text-gray-700" data-id="element-1763">
                            {activity.comment}
                          </div>}
                      </div>
                    </div>)}
                </div>
              </div>
            </div>}
          {activeTab === 'details' && <div className="p-6" data-id="element-1764">
              <div className="grid grid-cols-2 gap-8" data-id="element-1765">
                <div data-id="element-1766">
                  <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1767">
                    Workflow Details
                  </h3>
                  <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1768">
                    <div className="px-4 py-5 sm:p-6" data-id="element-1769">
                      <dl className="grid grid-cols-1 gap-x-4 gap-y-6" data-id="element-1770">
                        <div data-id="element-1771">
                          <dt className="text-sm font-medium text-gray-500" data-id="element-1772">
                            Workflow Name
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900" data-id="element-1773">
                            {workflow.name}
                          </dd>
                        </div>
                        <div data-id="element-1774">
                          <dt className="text-sm font-medium text-gray-500" data-id="element-1775">
                            Description
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900" data-id="element-1776">
                            {workflow.description}
                          </dd>
                        </div>
                        <div data-id="element-1777">
                          <dt className="text-sm font-medium text-gray-500" data-id="element-1778">
                            Department
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900" data-id="element-1779">
                            {workflow.department || 'General Manager Office'}
                          </dd>
                        </div>
                        <div data-id="element-1780">
                          <dt className="text-sm font-medium text-gray-500" data-id="element-1781">
                            Status
                          </dt>
                          <dd className="mt-1" data-id="element-1782">
                            <span className={`px-2 py-1 text-xs rounded-full ${getStatusStyles(workflow.status)}`} data-id="element-1783">
                              {workflow.status}
                            </span>
                          </dd>
                        </div>
                        <div data-id="element-1784">
                          <dt className="text-sm font-medium text-gray-500" data-id="element-1785">
                            Priority
                          </dt>
                          <dd className="mt-1" data-id="element-1786">
                            <span className={`px-2 py-1 text-xs rounded-full ${getPriorityStyles(workflow.priority || 'Medium')}`} data-id="element-1787">
                              {workflow.priority || 'Medium'}
                            </span>
                          </dd>
                        </div>
                        <div data-id="element-1788">
                          <dt className="text-sm font-medium text-gray-500" data-id="element-1789">
                            Created By
                          </dt>
                          <dd className="mt-1 text-sm text-gray-900" data-id="element-1790">
                            Jasim Alawadhi
                          </dd>
                        </div>
                      </dl>
                    </div>
                  </div>
                </div>
                <div data-id="element-1791">
                  <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1792">
                    Steps & Approvals
                  </h3>
                  <div className="space-y-4" data-id="element-1793">
                    {workflow.steps.map((step, index) => <div key={index} className="bg-white border border-gray-200 rounded-lg p-4" data-id="element-1794">
                        <div className="flex justify-between items-start mb-2" data-id="element-1795">
                          <div className="flex items-center" data-id="element-1796">
                            <div className={`h-8 w-8 rounded-full flex items-center justify-center mr-3 ${getStepStatusStyles(step.status)}`} data-id="element-1797">
                              {getStepStatusIcon(step.status)}
                            </div>
                            <div data-id="element-1798">
                              <h4 className="text-sm font-medium text-gray-800" data-id="element-1799">
                                Step {index + 1}: {step.name}
                              </h4>
                              <p className="text-xs text-gray-500 mt-0.5" data-id="element-1800">
                                {getStepStatusText(step.status)}
                              </p>
                            </div>
                          </div>
                          {step.status === 'current' && <button className="px-3 py-1 bg-blue-600 text-white text-xs rounded-md hover:bg-blue-700" data-id="element-1801">
                              Take Action
                            </button>}
                        </div>
                        <div className="pl-11" data-id="element-1802">
                          <div className="flex items-center text-xs text-gray-500 mb-2" data-id="element-1803">
                            <Users className="h-3 w-3 mr-1" data-id="element-1804" />
                            <span data-id="element-1805">
                              Assigned to: {step.assignee || 'Not assigned'}
                            </span>
                          </div>
                          {step.status === 'completed' && <div className="bg-green-50 border border-green-100 rounded-md p-2 mt-2" data-id="element-1806">
                              <div className="flex items-center text-xs text-green-800" data-id="element-1807">
                                <CheckCircle className="h-3 w-3 mr-1 text-green-600" data-id="element-1808" />
                                <span data-id="element-1809">
                                  Completed by Fatima Ahmed on Aug 8, 2023
                                </span>
                              </div>
                              {step.comment && <p className="text-xs text-green-700 mt-1" data-id="element-1810">
                                  {step.comment}
                                </p>}
                            </div>}
                          {step.status === 'rejected' && <div className="bg-red-50 border border-red-100 rounded-md p-2 mt-2" data-id="element-1811">
                              <div className="flex items-center text-xs text-red-800" data-id="element-1812">
                                <AlertCircle className="h-3 w-3 mr-1 text-red-600" data-id="element-1813" />
                                <span data-id="element-1814">
                                  Rejected by Mohammed Ali on Aug 10, 2023
                                </span>
                              </div>
                              {step.comment && <p className="text-xs text-red-700 mt-1" data-id="element-1815">
                                  {step.comment}
                                </p>}
                            </div>}
                        </div>
                      </div>)}
                  </div>
                </div>
              </div>
            </div>}
          {activeTab === 'documents' && <div className="p-6" data-id="element-1816">
              <div className="flex justify-between items-center mb-6" data-id="element-1817">
                <h3 className="text-lg font-medium text-gray-800" data-id="element-1818">
                  Related Documents
                </h3>
                <button className="px-4 py-2 bg-blue-600 text-white rounded-md text-sm hover:bg-blue-700 transition-colors flex items-center space-x-2" data-id="element-1819">
                  <FileText className="h-4 w-4" data-id="element-1820" />
                  <span data-id="element-1821">Attach Document</span>
                </button>
              </div>
              <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-1822">
                <table className="min-w-full divide-y divide-gray-200" data-id="element-1823">
                  <thead className="bg-gray-50" data-id="element-1824">
                    <tr data-id="element-1825">
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1826">
                        Document
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1827">
                        Added By
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1828">
                        Date Added
                      </th>
                      <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1829">
                        Status
                      </th>
                      <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1830">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-200" data-id="element-1831">
                    {workflowDocuments.map((doc, index) => <tr key={index} className="hover:bg-gray-50" data-id="element-1832">
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1833">
                          <div className="flex items-center" data-id="element-1834">
                            <div className="flex-shrink-0 h-10 w-10 bg-gray-100 rounded-md flex items-center justify-center" data-id="element-1835">
                              <FileText className="h-5 w-5 text-gray-500" data-id="element-1836" />
                            </div>
                            <div className="ml-4" data-id="element-1837">
                              <div className="text-sm font-medium text-gray-900" data-id="element-1838">
                                {doc.name}
                              </div>
                              <div className="text-xs text-gray-500" data-id="element-1839">
                                {doc.type} • {doc.size}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1840">
                          <div className="flex items-center" data-id="element-1841">
                            <div className="h-6 w-6 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800 mr-2" data-id="element-1842">
                              {doc.addedBy.initials}
                            </div>
                            <span className="text-sm text-gray-500" data-id="element-1843">
                              {doc.addedBy.name}
                            </span>
                          </div>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1844">
                          {doc.dateAdded}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap" data-id="element-1845">
                          <span className={`px-2 py-1 text-xs rounded-full ${getDocStatusStyles(doc.status)}`} data-id="element-1846">
                            {doc.status}
                          </span>
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1847">
                          <button className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-1848">
                            View
                          </button>
                          <button className="text-gray-600 hover:text-gray-900" data-id="element-1849">
                            <Download className="h-4 w-4" data-id="element-1850" />
                          </button>
                        </td>
                      </tr>)}
                  </tbody>
                </table>
              </div>
            </div>}
          {activeTab === 'history' && <div className="p-6" data-id="element-1851">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1852">
                Workflow History
              </h3>
              <div className="relative border-l-2 border-gray-200 ml-4 pl-6 space-y-6" data-id="element-1853">
                {workflowHistory.map((event, index) => <div key={index} className="relative" data-id="element-1854">
                    <div className="absolute -left-10 mt-1.5 h-4 w-4 rounded-full border-2 border-white bg-gray-300" data-id="element-1855"></div>
                    <div className="mb-1 flex items-baseline justify-between" data-id="element-1856">
                      <div data-id="element-1857">
                        <span className="text-sm font-medium text-gray-800" data-id="element-1858">
                          {event.title}
                        </span>
                        <span className="ml-2 text-xs text-gray-500" data-id="element-1859">
                          {event.date}
                        </span>
                      </div>
                      <span className="text-xs text-gray-500" data-id="element-1860">
                        {event.time}
                      </span>
                    </div>
                    <p className="text-sm text-gray-600" data-id="element-1861">{event.description}</p>
                    {event.details && <div className="mt-2 bg-gray-50 rounded-md p-3 text-sm text-gray-700" data-id="element-1862">
                        {event.details}
                      </div>}
                  </div>)}
              </div>
            </div>}
          {activeTab === 'comments' && <div className="p-6" data-id="element-1863">
              <h3 className="text-lg font-medium text-gray-800 mb-4" data-id="element-1864">
                Comments & Discussion
              </h3>
              <div className="mb-6" data-id="element-1865">
                <div className="flex space-x-3" data-id="element-1866">
                  <div className="flex-shrink-0" data-id="element-1867">
                    <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800" data-id="element-1868">
                      JA
                    </div>
                  </div>
                  <div className="min-w-0 flex-1" data-id="element-1869">
                    <div className="border border-gray-300 rounded-lg overflow-hidden focus-within:border-blue-500 focus-within:ring-1 focus-within:ring-blue-500" data-id="element-1870">
                      <textarea rows={3} className="block w-full resize-none border-0 p-3 focus:outline-none focus:ring-0 sm:text-sm" placeholder="Add a comment..." data-id="element-1871"></textarea>
                      <div className="border-t border-gray-200 px-3 py-2 flex justify-between items-center" data-id="element-1872">
                        <div className="flex space-x-2" data-id="element-1873">
                          <button className="p-1 text-gray-500 hover:text-gray-800 rounded" data-id="element-1874">
                            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1875">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" data-id="element-1876" />
                            </svg>
                          </button>
                          <button className="p-1 text-gray-500 hover:text-gray-800 rounded" data-id="element-1877">
                            <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1878">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1879" />
                            </svg>
                          </button>
                        </div>
                        <button className="px-4 py-1.5 bg-blue-600 text-white text-sm rounded-md hover:bg-blue-700" data-id="element-1880">
                          Comment
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="space-y-6" data-id="element-1881">
                {workflowComments.map((comment, index) => <div key={index} className="flex space-x-3" data-id="element-1882">
                    <div className="flex-shrink-0" data-id="element-1883">
                      <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center text-xs font-medium text-blue-800" data-id="element-1884">
                        {comment.user.initials}
                      </div>
                    </div>
                    <div className="flex-1 bg-white border border-gray-200 rounded-lg p-4" data-id="element-1885">
                      <div className="flex justify-between items-center mb-2" data-id="element-1886">
                        <div className="flex items-center" data-id="element-1887">
                          <span className="text-sm font-medium text-gray-900" data-id="element-1888">
                            {comment.user.name}
                          </span>
                          <span className="mx-2 text-gray-500" data-id="element-1889">•</span>
                          <span className="text-xs text-gray-500" data-id="element-1890">
                            {comment.date}
                          </span>
                        </div>
                        <button className="text-gray-400 hover:text-gray-600" data-id="element-1891">
                          <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1892">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h.01M12 12h.01M19 12h.01M6 12a1 1 0 11-2 0 1 1 0 012 0zm7 0a1 1 0 11-2 0 1 1 0 012 0z" data-id="element-1893" />
                          </svg>
                        </button>
                      </div>
                      <p className="text-sm text-gray-700" data-id="element-1894">{comment.text}</p>
                      {comment.attachments && <div className="mt-3 border border-gray-200 rounded-md p-2 bg-gray-50" data-id="element-1895">
                          <div className="flex items-center" data-id="element-1896">
                            <FileText className="h-4 w-4 text-gray-500 mr-2" data-id="element-1897" />
                            <span className="text-xs text-gray-700" data-id="element-1898">
                              {comment.attachments}
                            </span>
                          </div>
                        </div>}
                      <div className="mt-3 flex space-x-4 text-xs" data-id="element-1899">
                        <button className="text-gray-500 hover:text-gray-700" data-id="element-1900">
                          Reply
                        </button>
                        <button className="text-gray-500 hover:text-gray-700" data-id="element-1901">
                          React
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>}
        </div>
        {/* Footer */}
        <div className="px-6 py-4 border-t border-gray-200 flex justify-between" data-id="element-1902">
          <div className="flex items-center space-x-4" data-id="element-1903">
            <button className="flex items-center space-x-1 text-gray-500 hover:text-gray-700" data-id="element-1904">
              <Mail className="h-4 w-4" data-id="element-1905" />
              <span className="text-sm" data-id="element-1906">Notify Team</span>
            </button>
            <button className="flex items-center space-x-1 text-gray-500 hover:text-gray-700" data-id="element-1907">
              <Clock className="h-4 w-4" data-id="element-1908" />
              <span className="text-sm" data-id="element-1909">Set Reminder</span>
            </button>
          </div>
          <div className="flex items-center space-x-3" data-id="element-1910">
            <button className="px-4 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors" onClick={onClose} data-id="element-1911">
              Close
            </button>
            <button className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors flex items-center space-x-2" onClick={() => onEdit(workflow)} data-id="element-1912">
              <Edit className="h-4 w-4" data-id="element-1913" />
              <span data-id="element-1914">Edit Workflow</span>
            </button>
          </div>
        </div>
      </div>
    </div>;
};
// Helper functions
const getStatusStyles = status => {
  switch (status) {
    case 'In Progress':
      return 'bg-blue-100 text-blue-800';
    case 'Pending':
      return 'bg-yellow-100 text-yellow-800';
    case 'Completed':
      return 'bg-green-100 text-green-800';
    case 'Rejected':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
const getPriorityStyles = priority => {
  switch (priority) {
    case 'Low':
      return 'bg-gray-100 text-gray-800';
    case 'Medium':
      return 'bg-blue-100 text-blue-800';
    case 'High':
      return 'bg-yellow-100 text-yellow-800';
    case 'Urgent':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
const getStepStatusStyles = status => {
  switch (status) {
    case 'completed':
      return 'bg-green-100 text-green-600';
    case 'current':
      return 'bg-blue-100 text-blue-600';
    case 'pending':
      return 'bg-gray-100 text-gray-600';
    case 'rejected':
      return 'bg-red-100 text-red-600';
    default:
      return 'bg-gray-100 text-gray-600';
  }
};
const getStepStatusIcon = status => {
  switch (status) {
    case 'completed':
      return <CheckCircle className="h-5 w-5" data-id="element-1915" />;
    case 'current':
      return <Clock className="h-5 w-5" data-id="element-1916" />;
    case 'pending':
      return <div className="h-3 w-3 rounded-full bg-gray-400" data-id="element-1917"></div>;
    case 'rejected':
      return <X className="h-5 w-5" data-id="element-1918" />;
    default:
      return <div className="h-3 w-3 rounded-full bg-gray-400" data-id="element-1919"></div>;
  }
};
const getStepStatusText = status => {
  switch (status) {
    case 'completed':
      return 'Completed';
    case 'current':
      return 'In Progress';
    case 'pending':
      return 'Pending';
    case 'rejected':
      return 'Rejected';
    default:
      return 'Pending';
  }
};
const getActivityIcon = type => {
  switch (type) {
    case 'step':
      return <CheckCircle className="h-4 w-4 text-blue-600" data-id="element-1920" />;
    case 'document':
      return <FileText className="h-4 w-4 text-blue-600" data-id="element-1921" />;
    case 'comment':
      return <MessageSquare className="h-4 w-4 text-blue-600" data-id="element-1922" />;
    case 'user':
      return <Users className="h-4 w-4 text-blue-600" data-id="element-1923" />;
    default:
      return <Clock className="h-4 w-4 text-blue-600" data-id="element-1924" />;
  }
};
const getDocStatusStyles = status => {
  switch (status) {
    case 'Approved':
      return 'bg-green-100 text-green-800';
    case 'Pending Approval':
      return 'bg-yellow-100 text-yellow-800';
    case 'Rejected':
      return 'bg-red-100 text-red-800';
    default:
      return 'bg-gray-100 text-gray-800';
  }
};
const getExpectedCompletionDate = workflow => {
  // This would be a calculation based on steps and their due dates
  // For demo purposes, just return a date
  return workflow.dueDate || 'Sep 30, 2023';
};
// Sample data
const workflowActivities = [{
  type: 'step',
  user: 'Fatima Ahmed',
  description: 'completed the "Department Review" step',
  date: 'Today, 2:30 PM'
}, {
  type: 'comment',
  user: 'Fatima Ahmed',
  description: 'added a comment',
  date: 'Today, 2:28 PM',
  comment: "I've reviewed the budget proposal and everything looks good. Moving it to Finance for approval."
}, {
  type: 'document',
  user: 'Mohammed Ali',
  description: 'uploaded a new version of "Annual Budget 2023.pdf"',
  date: 'Yesterday, 11:45 AM'
}, {
  type: 'step',
  user: 'Jasim Alawadhi',
  description: 'completed the "Document Creation" step',
  date: 'Aug 15, 2023'
}, {
  type: 'user',
  user: 'Jasim Alawadhi',
  description: 'added Fatima Ahmed to the workflow',
  date: 'Aug 15, 2023'
}];
const workflowDocuments = [{
  name: 'Annual Budget 2023.pdf',
  type: 'PDF',
  size: '2.4 MB',
  addedBy: {
    name: 'Jasim Alawadhi',
    initials: 'JA'
  },
  dateAdded: 'Aug 15, 2023',
  status: 'Approved'
}, {
  name: 'Budget Justification.docx',
  type: 'Document',
  size: '1.2 MB',
  addedBy: {
    name: 'Mohammed Ali',
    initials: 'MA'
  },
  dateAdded: 'Aug 16, 2023',
  status: 'Pending Approval'
}];
const workflowHistory = [{
  title: 'Workflow Started',
  date: 'Aug 15, 2023',
  time: '10:30 AM',
  description: 'Jasim Alawadhi created and started the workflow'
}, {
  title: 'Document Creation Step Completed',
  date: 'Aug 15, 2023',
  time: '2:45 PM',
  description: 'Jasim Alawadhi completed the first step of the workflow'
}, {
  title: 'Document Added',
  date: 'Aug 15, 2023',
  time: '2:50 PM',
  description: 'Jasim Alawadhi added "Annual Budget 2023.pdf" to the workflow'
}, {
  title: 'Participant Added',
  date: 'Aug 15, 2023',
  time: '3:15 PM',
  description: 'Fatima Ahmed was added to the workflow as a reviewer'
}, {
  title: 'Department Review Step Started',
  date: 'Aug 15, 2023',
  time: '3:16 PM',
  description: 'The workflow moved to the "Department Review" step'
}, {
  title: 'Document Added',
  date: 'Aug 16, 2023',
  time: '11:45 AM',
  description: 'Mohammed Ali added "Budget Justification.docx" to the workflow'
}, {
  title: 'Department Review Step Completed',
  date: 'Today',
  time: '2:30 PM',
  description: 'Fatima Ahmed completed the "Department Review" step',
  details: 'Approved with comment: "I\'ve reviewed the budget proposal and everything looks good. Moving it to Finance for approval."'
}, {
  title: 'Finance Approval Step Started',
  date: 'Today',
  time: '2:31 PM',
  description: 'The workflow moved to the "Finance Approval" step'
}];
const workflowComments = [{
  user: {
    name: 'Jasim Alawadhi',
    initials: 'JA'
  },
  date: 'Aug 15, 2023 at 3:20 PM',
  text: "I've created the initial budget proposal. Please review and let me know if any changes are needed before we send it to Finance.",
  attachments: 'Annual Budget 2023.pdf'
}, {
  user: {
    name: 'Mohammed Ali',
    initials: 'MA'
  },
  date: 'Aug 16, 2023 at 11:50 AM',
  text: "I've added a justification document that explains the reasoning behind the budget allocations for each department. This should help with the approval process.",
  attachments: 'Budget Justification.docx'
}, {
  user: {
    name: 'Fatima Ahmed',
    initials: 'FA'
  },
  date: 'Today at 2:28 PM',
  text: "I've reviewed the budget proposal and everything looks good. Moving it to Finance for approval."
}];